module.exports = __webpack_public_path__ + "static/media/4-d.b850e92e.jpg";